__turbopack_context__.v({
  "arc": "LoadingOverlay-module-scss-module__ABETSa__arc",
  "contactOrgSpin": "LoadingOverlay-module-scss-module__ABETSa__contactOrgSpin",
  "indicator": "LoadingOverlay-module-scss-module__ABETSa__indicator",
  "overlay": "LoadingOverlay-module-scss-module__ABETSa__overlay",
  "spinner": "LoadingOverlay-module-scss-module__ABETSa__spinner",
  "track": "LoadingOverlay-module-scss-module__ABETSa__track",
});
